import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useComponentTypesContext } from "../componentTypes/context/ComponentTypeContext";
import { getComponentTypes } from "../componentTypes/repositories/ComponentTypes";
import { usePartComponentTypeContext } from "../partComponentTypes/context/PartComponentTypeContext";
import { getPartComponentType } from "../partComponentTypes/repositories/PartComponentTypeRepository";
import { usePartStateContext } from "../partState/context/PartsContext";
import { getPartState } from "../partState/repositories/PartsRepository";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { useVendorsContext } from "../vendors/context/VendorsContext";
import { getVendors } from "../vendors/repositories/VendorsRepository";
import { PartsTableData } from "./components/DataTable/PartsTableData";
import { usePartsContext } from "./context/PartsContext";
import { getParts } from "./repositories/PartsRepository";

export const Parts = () => {
	const { state, actions } = usePartsContext();
	const { state: vendors, actions: vendorsActions } = useVendorsContext();
	const { state: componentTypesState, actions: componentTypesActions } =
		useComponentTypesContext();
	const { state: partState, actions: partStateActions } = usePartStateContext();
	const { state: partComponentType, actions: partComponentTypeActions } =
		usePartComponentTypeContext();
	const { state: rootType, actions: rootTypeActions } = useRootTypeContext();

	const [isLoading, setIsLoading] = useState(true);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getPartsFromAPI = async () => {
		setIsLoading(true);

		const values = await Promise.all([
			getParts(),
			getPartState(),
			getVendors(),
			getPartComponentType(),
			getComponentTypes(),
			getRootTypes(),
		])
			.then((r) => {
				const [
					partsResp,
					partStateResp,
					{ vendors },
					partComponentTypeResp,
					{ componentTypes },
					{ rootTypes },
				] = r;

				if (partsResp.ok) {
					actions.setParts(partsResp.data?.data);
					vendorsActions.setVendors(vendors);
					partStateActions.setPartState(partStateResp.data?.data);
					partComponentTypeActions.setPartComponentType(
						partComponentTypeResp.data?.data,
					);
					componentTypesActions.setComponentTypes(componentTypes);
					rootTypeActions.setRootTypes(rootTypes);

					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
				setShowErrorModal(true);
			});
	};

	useEffect(() => {
		getPartsFromAPI();
	}, []);

	if (state.parts) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: "20px" }}>
						<Paper
							elevation={1}
							style={{
								width: "100%",
								padding: "10px 0 50px",
								borderRadius: "0.75rem",
							}}
						>
							<PartsTableData
								isLoading={isLoading}
								getPartsFromAPI={getPartsFromAPI}
							/>
						</Paper>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
